import React, { useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import { api, formatApiError, absUrl } from "@/lib/api";
import { toast } from "sonner";

export default function ImageUploader({ value = [], onChange, max = 20, testid = "image-uploader" }) {
    const [busy, setBusy] = useState(false);

    async function handleFiles(files) {
        const fileList = Array.from(files || []);
        if (!fileList.length) return;
        if (value.length + fileList.length > max) {
            toast.error(`Max ${max} photos`);
            return;
        }
        setBusy(true);
        try {
            const uploaded = [];
            for (const f of fileList) {
                const fd = new FormData();
                fd.append("file", f);
                const { data } = await api.post("/upload", fd, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
                uploaded.push(data.url);
            }
            onChange([...value, ...uploaded]);
        } catch (e) {
            toast.error(formatApiError(e));
        } finally {
            setBusy(false);
        }
    }

    return (
        <div data-testid={testid}>
            <div className="flex flex-wrap gap-3">
                {value.map((url, i) => (
                    <div
                        key={url + i}
                        className="relative w-24 h-24 rounded-md overflow-hidden surface"
                    >
                        <img src={absUrl(url)} alt="upload" className="w-full h-full object-cover" />
                        <button
                            type="button"
                            data-testid={`remove-image-${i}`}
                            onClick={() => onChange(value.filter((_, idx) => idx !== i))}
                            className="absolute top-1 right-1 w-6 h-6 flex items-center justify-center rounded-full"
                            style={{ background: "rgba(10,10,10,0.85)" }}
                            aria-label="Remove image"
                        >
                            <X className="w-3.5 h-3.5 text-white" />
                        </button>
                    </div>
                ))}
                {value.length < max && (
                    <label
                        className="w-24 h-24 rounded-md border-dashed border-2 border-onyx-600 flex flex-col items-center justify-center cursor-pointer text-onyx-500 hover:border-hellcat hover:text-hellcat"
                        style={{ transition: "border-color 0.15s, color 0.15s" }}
                        data-testid="uploader-input-label"
                    >
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={(e) => handleFiles(e.target.files)}
                            className="hidden"
                            data-testid="uploader-input"
                        />
                        {busy ? (
                            <Loader2 className="w-5 h-5 animate-spin" />
                        ) : (
                            <>
                                <Upload className="w-5 h-5" />
                                <span className="text-[10px] mt-1 label-caps">Add</span>
                            </>
                        )}
                    </label>
                )}
            </div>
        </div>
    );
}
